import { OfficeApi } from '../office/OfficeApi';
import MetadataService from './metadataService';
import { OutlookMetadataService } from './outlookMetadataService';
import { DocumentMetadataService } from './documentMetadataService';
import SchemaFieldsNamesProvider from 'titus-ts/dist/js/MetadataRenderer/Schema/SchemaFieldsNamesProvider';
import { GuidService } from './guidService';
import { AppSettingsService } from './appSettingsService';

export default class MetadataServiceFactory {
    private officeApi: OfficeApi;
    private schemaField: string[];
    private guidService: GuidService;
    private appSettingsService?: AppSettingsService;

    constructor(
        officeApi: OfficeApi,
        schemaFieldsNamesProvider: SchemaFieldsNamesProvider,
        guidService: GuidService,
        appSettingsService?: AppSettingsService,
    ) {
        this.officeApi = officeApi;
        this.schemaField = schemaFieldsNamesProvider.getSchemaFieldsNames();
        this.guidService = guidService;
        this.appSettingsService = appSettingsService;
    }

    public getMetadataServiceInstance = (): MetadataService => {
        let metadataService: MetadataService;
        switch (this.officeApi.getHost()) {
            case 'Outlook':
                metadataService = new OutlookMetadataService(this.officeApi, this.appSettingsService);
                break;
            case 'Excel':
            case 'Word':
            case 'PowerPoint':
                metadataService = new DocumentMetadataService(this.officeApi, this.schemaField, this.guidService);
                break;
        }
        return metadataService;
    };
}
